import { render, staticRenderFns } from "./TBody.vue?vue&type=template&id=36f68c8b&scoped=true&"
import script from "./TBody.vue?vue&type=script&lang=js&"
export * from "./TBody.vue?vue&type=script&lang=js&"
import style0 from "./TBody.vue?vue&type=style&index=0&id=36f68c8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f68c8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCheckbox,VDivider,VIcon,VList,VListItem,VListItemTitle,VMenu})
